import axios from 'axios';
export const LOADING = 'LOADING';
export const DOCUMENT_TYPE_FILTER = 'DOCUMENT_TYPE_FILTER';

export function documentTypeFilter( document_type_slug ) {
	return ( dispatch ) => {
		dispatch( {
			          type: DOCUMENT_TYPE_FILTER, payload: document_type_slug
		          } );
		};
}


function get_config() {
	let config = {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	};
	return config;
}